// types
import { Entity, TraceabilityTransactions, Wallet } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { BlockchainHash } from '../../../ui/BlockchainHash/BlockchainHash';
import { ChipTraceability } from '../../../ui/ChipTraceability/ChipTraceability';
import { Time } from '../../../ui/Time/Time';
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// links
import { LinkEntity } from '../../../links/LinkEntity/LinkEntity';

// config
import { featureFlags } from '../../../../config/featureFlags';

// props
export interface TableBasicEntitiesProps extends Omit<TableProps, 'headers'> {
	data: Entity[];
}

export const TableBasicEntities = ({ data = [], ...props }: TableBasicEntitiesProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableProps['headers'] = [
		{
			label: t('name'),
			render: (name: string, header: TableHeader, entity: Entity) => {
				return <LinkEntity entity={entity} />;
			},
			value: 'name',
		},
		{
			label: t('wallet'),
			render: (wallet: Wallet) => {
				return <BlockchainHash hash={wallet?.address} />;
			},
			value: 'wallet',
		},
		{
			label: t('created'),
			render: (created: string) => {
				return <Time date={created} />;
			},
			value: 'created',
		},
		{
			label: t('transactionsEvidenced'),
			render: (traceability: TraceabilityTransactions) => {
				return <ChipTraceability traceability={traceability} type="TRANSACTIONS" />;
			},
			value: 'traceability',
		},
	];

	// Add financial traceability column conditionally based on feature flag
	if (featureFlags['FINANCIAL_TRACEABILITY']) {
		headers.push({
			label: t('financialValueEvidenced'),
			render: (traceability: TraceabilityTransactions) => {
				return <ChipTraceability traceability={traceability} type="FINANCIAL" />;
			},
			value: 'traceability',
		});
	}

	return <Table {...props} data={data} headers={headers} />;
};
